export const productPath = (p, suffix = '') => `/produit/${encodeURIComponent((p && typeof p === 'object' ? p.slug || p.id : p) || '')}${suffix}`;
